/**
 * Returns `value` as a normalised absolute http(s) URL, or null.
 *
 * Use this before rendering any tenant-controlled URL (the organization's CMMS,
 * LIMS and OEE URL templates) as an `href` / router `to`. Those values are
 * entered by tenant admins, so a stored `javascript:` or `data:` URI would run
 * script in our origin on click, where the auth tokens live in localStorage.
 *
 * The value is parsed without a base URL on purpose: relative and
 * protocol-relative values (`/path`, `//host/path`, `www.host/path`) are
 * rejected rather than resolved against the current origin. Callers treat a
 * null result exactly like a missing URL and render no link.
 */
export const safeExternalUrl = (value: string | null | undefined): string | null => {
  if (typeof value !== 'string' || value === '') {
    return null
  }

  let url: URL
  try {
    url = new URL(value)
  } catch {
    return null
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    return null
  }

  return url.href
}
